import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Switch } from "@/components/ui/switch";

const KEY = "esprit_cookie_consent";

// No intrusive banner. Preferences open only from the footer "Cookie Preferences"
// link or the Privacy page — cleaner for older visitors and mobile.
export const CookieConsent = () => {
  const [prefsOpen, setPrefsOpen] = useState(false);
  const [measurement, setMeasurement] = useState(false);
  const [marketing, setMarketing] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(KEY);
    if (stored) {
      try {
        const c = JSON.parse(stored);
        setMeasurement(!!c.measurement);
        setMarketing(!!c.marketing);
      } catch (e) { /* ignore */ }
    }
    const handler = () => setPrefsOpen(true);
    window.addEventListener("open-cookie-preferences", handler);
    return () => window.removeEventListener("open-cookie-preferences", handler);
  }, []);

  const save = (consent) => {
    localStorage.setItem(KEY, JSON.stringify({ ...consent, technical: true, ts: Date.now() }));
    setPrefsOpen(false);
  };

  return (
    <Dialog open={prefsOpen} onOpenChange={setPrefsOpen}>
      <DialogContent className="max-w-md" data-testid="cookie-prefs-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading text-2xl">Privacy Preferences</DialogTitle>
          <DialogDescription>
            We use cookies for technical purposes and, with your consent, for measurement and marketing. Choose what you allow — you can change this anytime.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div className="flex items-start justify-between gap-4 bg-muted rounded-xl p-4">
            <div><p className="font-semibold">Technical (always active)</p><p className="text-sm text-muted-foreground">Required for the site to function.</p></div>
            <Switch checked disabled />
          </div>
          <div className="flex items-start justify-between gap-4 bg-card border border-border rounded-xl p-4">
            <div><p className="font-semibold">Measurement</p><p className="text-sm text-muted-foreground">Helps us understand how visitors use the site.</p></div>
            <Switch checked={measurement} onCheckedChange={setMeasurement} data-testid="cookie-toggle-measurement" />
          </div>
          <div className="flex items-start justify-between gap-4 bg-card border border-border rounded-xl p-4">
            <div><p className="font-semibold">Marketing (personalized ads)</p><p className="text-sm text-muted-foreground">Used to show you relevant content and ads.</p></div>
            <Switch checked={marketing} onCheckedChange={setMarketing} data-testid="cookie-toggle-marketing" />
          </div>
        </div>
        <DialogFooter className="gap-2 sm:gap-2">
          <button onClick={() => save({ measurement: false, marketing: false })}
            className="rounded-full border-2 border-primary text-primary hover:bg-muted h-11 px-5 font-semibold transition-colors">
            Reject all
          </button>
          <button data-testid="cookie-save-prefs" onClick={() => save({ measurement, marketing })}
            className="rounded-full bg-primary hover:bg-primary/90 text-primary-foreground h-11 px-5 font-semibold transition-colors">
            Save preferences
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
